import React, { useContext, useState, useEffect, Fragment } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import Email from "./../inputs/Email";
import { Checkbox } from "semantic-ui-react";
import Password from "./../inputs/Password";
import { BasicContext } from "../../App";
import ReCAPTCHA from "react-google-recaptcha";
import { validateEmail, validatePassword } from "../../commonData";
import ModalWithEmail from "../modals/ModalWithEmail";
import { postMethod } from "../../requests";

const RegisterForm = (props) => {
    const { blockForm, onBlockForm } = props;
    const { t } = useTranslation();
    const { setAlerts, theme, checkServerData } = useContext(BasicContext);
    const [sendActivationLinkModal, setSendActivationLinkModal] = useState(false);
    const initData = {
        email: "",
        password: "",
        repeatPassword: "",
        name: "",
        surname: "",
        phone: "",
        ig: "",
        address: "",
        regulations: false,
        rodo: false,
        newsletter: false,
        ecc: false,
        token: null,
    };
    const [register, setRegister] = useState(initData);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (register.email.length === 0 || !register.email.replace(/\s+/, "")) {
            $("#registerFormEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(register.email)) {
            $("#registerFormEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        } else if (register.email.length > 255) {
            $("#registerFormEmail").addClass("is-invalid");
            errors.push(t("error.userEmailTooLong"));
        } else $("#registerFormEmail").removeClass("is-invalid");

        if (register.password.length === 0 || !register.password.replace(/\s+/, "")) {
            $("#registerFormPassword").addClass("is-invalid");
            errors.push(t("error.emptyFirstPassword"));
        } else if (register.password.length > 64) {
            $("#registerFormPassword").addClass("is-invalid");
            errors.push(t("error.passwordTooLong"));
        } else if (!validatePassword(register.password)) {
            $("#registerFormPassword").addClass("is-invalid");
            errors.push(t("error.invalidPassword"));
        } else $("#registerFormPassword").removeClass("is-invalid");

        if (register.repeatPassword.length === 0 || !register.repeatPassword.replace(/\s+/, "")) {
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.emptySecondPassword"));
        } else if (register.password.length > 64) {
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.repeatPasswordTooLong"));
        } else if (!validatePassword(register.repeatPassword)) {
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.invalidSecondPassword"));
        } else $("#registerFormRepeatPassword").removeClass("is-invalid");

        if (register.password !== register.repeatPassword) {
            $("#registerFormPassword").addClass("is-invalid");
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.passwordsAreNotTheSame"));
        }

        if (register.name.length === 0 || !register.name.replace(/\s+/, "")) {
            $("#registerFormname").addClass("is-invalid");
            errors.push(t("error.emptyName"));
        } else if (register.name.length > 50) {
            $("#registerFormname").addClass("is-invalid");
            errors.push(t("error.userNameTooLong"));
            /*  } else if (!/[0-9!@#$%^&*(),.?":{}|<>_+=\-[\]\\`~;'/]+/.test(register.name)) {
            $("#registerFormname").addClass("is-invalid");
            errors.push(t("error.invalidUserName")); */
        } else $("#registerFormname").removeClass("is-invalid");

        if (register.surname.length === 0 || !register.surname.replace(/\s+/, "")) {
            $("#registerFormsurname").addClass("is-invalid");
            errors.push(t("error.emptySurname"));
        } else if (register.surname.length > 50) {
            $("#registerFormsurname").addClass("is-invalid");
            errors.push(t("error.userSurnameTooLong"));
            /* } else if (!/[0-9!@#$%^&*(),.?":{}|<>_+=\-[\]\\`~;'/]+/.test(register.surname)) {
            $("#registerFormsurname").addClass("is-invalid");
            errors.push(t("error.invalidUserSurname")); */
        } else $("#registerFormsurname").removeClass("is-invalid");

        if (register.phone.length === 0 || !register.phone.replace(/\s+/, "")) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(register.phone)) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        } else if (register.phone.length > 30) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.userPhoneTooLong"));
        } else $("#registerFormphone").removeClass("is-invalid");

        if (register.ig.length > 0 && !/^(?!.*\.\.)(?!.*\.$)(?!\d+$)[a-zA-Z0-9._]{1,30}$/.test(register.ig)) {
            $("#registerFormig").addClass("is-invalid");
            errors.push(t("error.invalidIgNick"));
        } else if (register.ig.length > 0 && register.ig.length > 30) {
            $("#registerFormig").addClass("is-invalid");
            errors.push(t("error.userInstagramTooLong"));
        } else $("#registerFormig").removeClass("is-invalid");

        if (!register.regulations) errors.push(t("error.notCheckedRegulations"));

        if (!register.rodo) errors.push(t("error.notCheckedRodo"));

        if (register.address.length > 0 && !register.address.replace(/\s+/, "")) {
            $("#registerFormAddress").addClass("is-invalid");
            errors.push(t("error.invalidAddress"));
        } else if (register.address.length > 0 && register.address.length > 255) {
            $("#registerFormAddress").addClass("is-invalid");
            errors.push(t("error.userAddressTooLong"));
        } else $("#registerFormAddress").removeClass("is-invalid");

        if (!register.token) errors.push(t("error.noCaptcha"));

        if (errors.length > 0) {
            setAlerts([
                {
                    variant: "danger",
                    message: (
                        <div>
                            <p>{t("appearedErrors")}:</p>
                            <p>
                                {errors.map((e, i) => (
                                    <span key={i}>
                                        {e}
                                        {i + 1 < errors.length ? " " : ""}
                                    </span>
                                ))}
                            </p>
                        </div>
                    ),
                },
            ]);
        } else {
            onBlockForm(true);
            $("#registerFormPassword").removeClass("is-invalid");
            $("#registerFormRepeatPassword").removeClass("is-invalid");
            setAlerts([{ variant: "info", message: t("info.signingIn") }]);
            registerUser();
        }
    };

    const registerUser = async () => {
        const res = await postMethod("/register", { user: register });
        if (checkServerData(res)) {
            setAlerts([
                { variant: res.data.variant, message: t(`${res.data.variant}.${res.data.code}`), fading: res.data.variant === "success" ? 2500 : null, id: "registerAlert" },
            ]);
            setRegister(initData);
        }
        onBlockForm(false);
    };

    const textInputs = [
        { name: "name", req: true, xs: 12, xl: 5 },
        { name: "surname", req: true, xs: 12, xl: 7 },
        { name: "phone", req: true, xs: 12, xl: 6 },
        { name: "ig", req: false, xs: 12, xl: 6 },
    ];

    const sendActivationLinkAgain = async (passData) => {
        const res = await postMethod("/send-activation-link", { userEmail: passData.username, token: passData.token });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2500, id: "emailSent" }]);
        } else onBlockForm(false);
    };

    useEffect(() => {
        document.querySelector("textarea").addEventListener("input", function () {
            this.style.height = "auto";
            this.style.height = `${this.scrollHeight}px`;
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Row>
                <Col xs={12}>
                    <p className="mb-3">{t("registerForm.txt")}</p>
                    <p className="mb-3">
                        {t("registerForm.noActivationLink")}{" "}
                        <Button variant="link" className="p-0 d-inline-block" onClick={() => setSendActivationLinkModal(true)}>
                            {t("registerForm.sendActivationLink")}
                        </Button>
                    </p>
                </Col>
                <Col xs={12}>
                    <Form onSubmit={checkValidation} autoComplete="off">
                        <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                        <Row>
                            <Col xs={12}>
                                <Email
                                    id="registerFormEmail"
                                    onChange={(e) => setRegister({ ...register, email: e.target.value })}
                                    blockForm={blockForm}
                                    value={register.email}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col xs={12} xl={12}>
                                <Form.Group controlId="registerFormPassword">
                                    <div className="mb-1">
                                        <Password
                                            autoComplete="new-password"
                                            value={register.password}
                                            onChange={(e) => {
                                                setRegister({ ...register, password: e.target.value });
                                                $("#registerFormPassword").removeClass("is-invalid");
                                            }}
                                            disabled={blockForm}
                                            btnID="showPass"
                                            label={t("password")}
                                            helper={t("passwordHelper")}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col xs={12} xl={12}>
                                <Form.Group className="mb-3" controlId="registerFormRepeatPassword">
                                    <Password
                                        autoComplete="new-password2"
                                        value={register.repeatPassword}
                                        onChange={(e) => {
                                            setRegister({ ...register, repeatPassword: e.target.value });
                                            $("#registerFormRepeatPassword").removeClass("is-invalid");
                                        }}
                                        disabled={blockForm}
                                        btnID="repeatPass"
                                        rpp
                                    />
                                </Form.Group>
                            </Col>
                            {textInputs.map((e, i) => (
                                <Col xs={e.xs} xl={e.xl} key={i}>
                                    <Form.Group className="mb-3" controlId={`registerForm${e.name}`}>
                                        <Form.Label className="w-100">
                                            {t(`registerForm.${e.name}`)} {e.req && <span className="text-danger">*</span>}
                                        </Form.Label>
                                        <Form.Control
                                            value={register[e.name]}
                                            onChange={(el) => setRegister({ ...register, [e.name]: el.target.value })}
                                            placeholder={t(`registerForm.${e.name}Placeholder`)}
                                            type="text"
                                            disabled={blockForm}
                                        />
                                    </Form.Group>
                                </Col>
                            ))}
                            <Col xs={12}>
                                <Form.Group className="mb-3" controlId={`registerFormAddress`}>
                                    <Form.Label className="w-100">{t(`registerForm.address`)}</Form.Label>
                                    <Form.Control
                                        value={register.address}
                                        onChange={(el) => {
                                            $("#registerFormAddress").removeClass("is-invalid");
                                            setRegister({ ...register, address: el.target.value });
                                        }}
                                        placeholder={t(`registerForm.addressPlaceholder`)}
                                        as="textarea"
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group>
                                    <Checkbox
                                        label={
                                            <label className="form-label">
                                                {t("registerForm.regulations")} <span className="text-danger">*</span>
                                                <br />
                                                <a href="/files/Regulamin-PT-2025.pdf" target="_blank">
                                                    {t("studioRegulations")}
                                                </a>
                                            </label>
                                        }
                                        checked={register.regulations}
                                        onChange={() => {
                                            setRegister({ ...register, regulations: !register.regulations });
                                            $("#registerFormRegulations").removeClass("is-invalid");
                                        }}
                                        id="registerFormRegulations"
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group id="privacyPolicyCheckbox">
                                    <Checkbox
                                        label={
                                            <label className="form-label">
                                                {t("registerForm.rodo")} <span className="text-danger me-3">*</span>
                                            </label>
                                        }
                                        checked={register.rodo}
                                        onChange={() => {
                                            setRegister({ ...register, rodo: !register.rodo });
                                            $("#registerFormRodo").removeClass("is-invalid");
                                        }}
                                        id="registerFormRodo"
                                    />
                                    <a href="/files/Pole_Therapy_polityka_prywatności.pdf" target="_blank" className="btn btn-link">
                                        {t("privacyPolicy")}
                                    </a>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group>
                                    <Checkbox
                                        label={<label className="form-label">{t("registerForm.ecc")}</label>}
                                        id="registerFormEcc"
                                        checked={register.ecc}
                                        onChange={() => {
                                            setRegister({ ...register, ecc: !register.ecc });
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group>
                                    <Checkbox
                                        label={<label className="form-label">{t("registerForm.newsletter")}</label>}
                                        id="registerFormNewsletter"
                                        checked={register.newsletter}
                                        onChange={() => {
                                            setRegister({ ...register, newsletter: !register.newsletter });
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group>
                                    <Col xs={12} className="text-center my-3" id="recaptcha">
                                        <ReCAPTCHA
                                            sitekey={process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY}
                                            onChange={(value) => setRegister({ ...register, token: value })}
                                            theme={theme}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Button variant="primary" className="w-100 mt-4 mb-4" type="submit" disabled={blockForm}>
                                    {t("registerForm.registerBtn")}
                                </Button>
                            </Col>
                            <Col xs={12}>
                                <p className="text-center mb-5">
                                    {t("registerForm.noActivationLink")}{" "}
                                    <Button variant="link" className="p-0 d-inline-block" onClick={() => setSendActivationLinkModal(true)}>
                                        {t("registerForm.sendActivationLink")}
                                    </Button>
                                </p>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                {sendActivationLinkModal ? (
                    <ModalWithEmail
                        translate={"sendActivationLinkModal"}
                        show={true}
                        blockForm={blockForm}
                        onProceed={(data) => {
                            onBlockForm(true);
                            sendActivationLinkAgain(data);
                        }}
                        onClose={() => {
                            setSendActivationLinkModal(false);
                            setAlerts([]);
                        }}
                    />
                ) : null}
            </Row>
        </Fragment>
    );
};

export default RegisterForm;
